'use client'

import SectionSwiper from '@component/layout/section/swiper'
import ListingsStandard, { SkeletonCard } from '@component/card/listings/standard'
import Select from '@component/select'
import { HOUSE_BATHROOMS, HOUSE_BEDROOMS } from '@config'
import { useCallback, useMemo, useState } from 'react'
import { assign, filter, first, isEqual, map, range, size, sortBy } from 'lodash-es'
import useFetch from '@hooks/useFetch'

export default function PropertiesAvailableContent({
  data,
  isProject,
  params
}) {

  const [bedrooms, setBedrooms] = useState([first(HOUSE_BEDROOMS)])
  const [bathrooms, setBathrooms] = useState([first(HOUSE_BATHROOMS)])
  const [carspaces, setCarspaces] = useState([first(HOUSE_BATHROOMS)])

  const param = useMemo(() => {
    const bedroom = getIds(bedrooms)
    const bathroom = getIds(bathrooms)
    const carspace = getIds(carspaces)
    return assign(
      {},
      params,
      bedroom ? { bedrooms: bedroom } : undefined,
      bathroom ? { bathrooms: bathroom } : undefined,
      carspace ? { carspaces: carspace } : undefined
    )
  }, [params, bedrooms, bathrooms, carspaces])
  const isDefalut = isEqual(param, params)
  const { isLoading, data: clientData } = useFetch(isDefalut ? null : { url: 'houses/list', params: param })
  const viewData = useMemo(() => isDefalut ? data : clientData, [data, clientData, isDefalut])

  const changeHandle = useCallback((set) => {
    return (val, item) => {
      let res = []
      const d = filter(val, item => item.value !== null)
      if (item.value === null) {
        res = [first(HOUSE_BEDROOMS)]
      } else if (d.length === 5) {
        res = [first(HOUSE_BEDROOMS)]
      } else if (d.length > 0) {
        res = d
      } else {
        res = [first(HOUSE_BEDROOMS)]
      }
      set(sortBy(res, 'value'))
    }
  }, [])

  return (
    <>
      {
        isProject && (
          <div className='flex items-center gap-x-10 relative z-10 mb-10'>
            <Select data={HOUSE_BEDROOMS} value={bedrooms} onChange={changeHandle(setBedrooms)} border multi prefix='Bedrooms: '></Select>
            <Select data={HOUSE_BATHROOMS} value={bathrooms} onChange={changeHandle(setBathrooms)} border multi prefix='Bathrooms: '></Select>
            <Select data={HOUSE_BATHROOMS} value={carspaces} onChange={changeHandle(setCarspaces)} border multi prefix='Parking: '></Select>
          </div>
        )
      }
      {
        isLoading && (
          <SectionSwiper data={range(0, 4)} Card={SkeletonCard}></SectionSwiper>
        )
      }
      {
        !isLoading && size(viewData) > 0 && (
          <SectionSwiper data={viewData} dataKey='id' slideClassName='py-12' swiperClassName='-my-12' Card={ListingsStandard}></SectionSwiper>
        )
      }
    </>
  )
}

function getIds(list) {
  return map(filter(list, item => item.value !== null), 'value').join(',')
}
